import { datadogRum } from '@datadog/browser-rum'
import { UserSession } from '@/domains/auth/AuthenticationPort'
import { RuntimeConfig } from '@/infra/env/getEnv'

export const initializeDatadogRum = (runtimeConfig: RuntimeConfig, currentVersion: string) => {
  datadogRum.init({
    applicationId: runtimeConfig.DATADOG_APPLICATION_ID,
    clientToken: runtimeConfig.DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.eu',
    service: 'instore-fcs-front',
    env: runtimeConfig.ENVIRONMENT,
    version: currentVersion,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    trackViewsManually: false,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: 'mask-user-input',
    beforeSend: (event) => {
      if (event.type === 'error' && /amplitude/i.test(event.error.message)) {
        return false
      }
      return !(event.type === 'resource' && event.resource.provider?.domain === 'amplitude.com')
    },
  })

  datadogRum.startSessionReplayRecording()
}

export const setUserForDatadogRum = (userSession: UserSession) => {
  datadogRum.setUser({
    name: userSession.name,
    email: userSession.email,
    id: userSession.id,
  })
}

export const setGlobalContextPropertiesForDatadogRum = () => {
  datadogRum.setGlobalContextProperty('feature', 'fcs')
  datadogRum.setGlobalContextProperty('userAgent', window.navigator.userAgent)
  datadogRum.setGlobalContextProperty('devicePixelRatio', window.devicePixelRatio)
  datadogRum.setGlobalContextProperty('screenWidth', window.screen.width)
  datadogRum.setGlobalContextProperty('screenHeight', window.screen.height)
  datadogRum.setGlobalContextProperty('innerWidth', window.innerWidth)
  datadogRum.setGlobalContextProperty('innerHeight', window.innerHeight)

  const visualViewportScale = window.visualViewport?.scale
  if (typeof visualViewportScale === 'number') {
    datadogRum.setGlobalContextProperty('visualViewportScale', visualViewportScale)
  }
}
